import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerManualSettlementTable from '../components/CheckerManualSettlementTable';
interface CheckerManualSettlementProps {
  onLogout: () => void;
}
export default function CheckerManualSettlement({
  onLogout
}: CheckerManualSettlementProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-2723">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Checker - Manual Settlement" data-id="element-2724" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-manual-settlement" data-id="element-2725" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-2726">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-2727">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-2728">
            <Icon icon="lucide:stamp" width={28} height={28} color="#0EA5E9" data-id="element-2729" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-2730">
              Checker Inbox - Manual Settlement
            </Typography>
          </Box>
          <CheckerManualSettlementTable data-id="element-2731" />
        </Box>
      </Box>
    </Box>;
}